import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Modal from '@components/Modal/Modal';
import styles from './GridDisplayer.css';

const getImagePath = image => require(`@assets/images/grids/${image}.png`);

class GridDisplayer extends Component {

  static propTypes = {
    colors: PropTypes.arrayOf(PropTypes.object),
    component: PropTypes.func.isRequired,
    file: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  };

  state = {
    modalOpened: false
  }

  handleOverlayClick = e => {
    e.preventDefault();

    this.setState({
      modalOpened: true
    });
  }

  onCloseModal = () => {
    this.setState({
      modalOpened: false
    });
  }

  render() {
    const  { name, image, colors, component } = this.props;
    const { modalOpened } = this.state;

    const displayerClasses = classnames(
      styles.displayerContainer,
      'flex flex-column'
    );

    return (
      <div className={displayerClasses}>
        <div className={styles.top} style={{ backgroundImage: `url(${getImagePath(image)})` }}>
          <div
            className={classnames(styles.overlay, 'flex flex-align-center flex-justify-center')}
            onClick={this.handleOverlayClick}
          >
            <span className="section-title">Preview Grid</span>
          </div>
          <Modal
            open={modalOpened}
            onClose={this.onCloseModal}
            customClasses={styles.fullScreenModal}
          >
            {component()}
          </Modal>
        </div>
        <div className={classnames(styles.bottom, 'flex-column flex-justify-between')}>
          <p className={classnames(styles.name, 'small')}>{name}</p>

          <ul className={styles.colorList}>
            {colors.map((color, i) => (
              <li key={`color-${i}`} className="flex flex-align-center">
                <span style={{ backgroundColor: color.variation }}></span>
                <p className="small">{color.description}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  }
}

export default GridDisplayer;



// WEBPACK FOOTER //
// ./src/containers/foundations/Grids/GridDisplayer/GridDisplayer.js